import { useTranslation } from "react-i18next";
import { Modal, Typography } from "antd";
import { useState, useMemo } from "react";
import TableData from "../../table-data/TableData";

interface Student {
	userId: number;
	email: string;
}

interface Props {
	open: boolean;
	onClose: () => void;
	onConfirmSuccess: () => void;
	students: Student[];
	loadingConfirm?: boolean;
}

const ListStudentAddedToCourseModal = ({
	open,
	onClose,
	onConfirmSuccess,
	students,
	loadingConfirm,
}: Props) => {
  const { t } = useTranslation();
	const [pageNumber, setPageNumber] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const columns = [
		{
			title: "STT",
			dataIndex: "index",
			width: 60,
			render: (_: any, __: any, index: number) =>
				(pageNumber - 1) * pageSize + index + 1,
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "email",
		},
	];

	const pagedStudents = useMemo(
		() =>
			students.slice((pageNumber - 1) * pageSize, pageNumber * pageSize),
		[students, pageNumber, pageSize]
	);

	return (
		<Modal
			open={open}
			onCancel={onClose}
			onOk={onConfirmSuccess}
			confirmLoading={loadingConfirm}
			okText={t("Xác nhận", "Xác nhận")}
			cancelText={t("Huỷ", "Huỷ")}
			title={t("Danh sách học viên đã được thêm vào khoá học", "Danh sách học viên đã được thêm vào khoá học")}
			width="60vw"
			height="70vh"
			centered
		>
			<div
				style={{ height: "60vh", marginTop: 24 }}
			>
				<Typography.Paragraph>
					{t("Tổng số:", "Tổng số:")} <b>{students.length}</b> {t("học viên", "học viên")}
				</Typography.Paragraph>
				<TableData
					dataTable={pagedStudents}
					dataColumns={columns}
					totalRecords={students.length}
					pageNumber={pageNumber}
					pageSize={pageSize}
					setPageNumber={setPageNumber}
					setPageSize={setPageSize}
					scroll={{ x: 400, y: 400 }}
					pagination={true}
					handleTableChangeProps={() => { }}
					hideSelection={false}

				/>
			</div>
		</Modal>
	);
};

export default ListStudentAddedToCourseModal;
